import React from "react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const PageHeader = ({
  text,
  subtext,
  image
}) => {

  const [headerRef, isHeaderVisible] = useScrollAnimation({ threshold: 0.1 });
  return (
    <div ref={headerRef} className={`mt-12 relative font-nunito grid grid-cols-1 lg:grid-cols-5 transition-all duration-1000 ease-out transform ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}>
      <div className="flex flex-col justify-center text-center md:text-left p-8 mx-24 lg:col-span-2">
        <h1 className="text-4xl md:text-6xl font-bold text-black mb-4 leading-tight">{text}</h1>
        <p className="text-gray-800 text-2xl mb-8 leading-relaxed">{subtext}</p>
      </div>
      <div className="relative max-h-96 overflow-hidden lg:col-span-3">
        <img
          src={image}
          alt={`img-${text}`}
          className="w-full h-full object-cover"
          style={{
            clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)'
          }}
        />
      </div>
    </div>
  )
}